import { Badge, Flex, Grid, Text } from "@mantine/core";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { DateField, NumberField, Show, TextField } from "@refinedev/mantine";
import { DetailsPair, DetailsCard } from "components/common/show/DetailsPair";
import {
  ReviewRequestBlacklist,
  REASON_COLORS,
  REASON_LABELS,
  REASON_DESCRIPTIONS,
} from "entities/review_request_blacklist";

export const ReviewRequestBlacklistShow: React.FC<
  IResourceComponentsProps
> = () => {
  const { queryResult } = useShow<ReviewRequestBlacklist>();
  const { data, isLoading } = queryResult;

  const record = data?.data;
  if (!record) return <div />;

  return (
    <Show isLoading={isLoading}>
      <Grid>
        <Grid.Col span={8}>
          <Flex direction="column" gap="sm">
            <DetailsCard title="Blacklist Details">
              <Flex direction="column" gap="sm">
                <DetailsPair>
                  <Text fw={700}>Email</Text>
                  <Text size="sm" weight={500}>
                    {record.email}
                  </Text>
                </DetailsPair>
                <DetailsPair>
                  <Text fw={700}>Reason</Text>
                  <Flex align="center" gap="sm">
                    <Badge
                      variant="filled"
                      color={REASON_COLORS[record.reason] || "gray"}
                      size="sm"
                      radius="sm"
                    >
                      {REASON_LABELS[record.reason] || record.reason}
                    </Badge>
                  </Flex>
                </DetailsPair>
                {REASON_DESCRIPTIONS[record.reason] && (
                  <DetailsPair>
                    <Text fw={700}>Reason Description</Text>
                    <Text size="sm" color="dimmed" italic>
                      {REASON_DESCRIPTIONS[record.reason]}
                    </Text>
                  </DetailsPair>
                )}
                <DetailsPair>
                  <Text fw={700}>Source Detail</Text>
                  <TextField
                    value={record.source_detail || "—"}
                  />
                </DetailsPair>
              </Flex>
            </DetailsCard>
          </Flex>
        </Grid.Col>

        <Grid.Col span={4}>
          <Flex direction="column" gap="sm">
            <DetailsCard title="ID">
              <NumberField value={record.id} />
            </DetailsCard>
            <DetailsCard title="Status">
              <Badge
                variant="filled"
                color={REASON_COLORS[record.reason] || "gray"}
                size="md"
              >
                {REASON_LABELS[record.reason] || record.reason}
              </Badge>
            </DetailsCard>
            <DetailsCard title="Created At">
              <DateField value={record.created_at} format="YYYY-MM-DD HH:mm" />
            </DetailsCard>
            <DetailsCard title="Updated At">
              <DateField value={record.updated_at} format="YYYY-MM-DD HH:mm" />
            </DetailsCard>
          </Flex>
        </Grid.Col>
      </Grid>
    </Show>
  );
};
